import ErrorToolTipView from 'views/utils/ErrorToolTipView';

/**
 * Constructs a ToolTipErrorReporter.
 * @param args
 *      message: A string or a function for the message to display. If a function, the value and validation result is provided
 *      element: The element being validated.
 *      position: The position for the tooltip.
 *      scrollableElement: In the case that a tooltip is bound to an element that is placed within scrollable content,
 *          the tooltip won't move with that element. You can provide that scrollable element and this reporter will
 *          hide and display again once scrolling stops.
 * @constructor
 */
var ToolTipErrorReporter = function(args) {
    this.message = args.message;
    this.element = args.element;
    this.position = args.position;
    this.scrollableElement = args.scrollableElement;
    this.value = null; // Current value for the result.
    this.result = null; // The current validation result.

    if (!this.message) {
        throw 'Message is required.';
    }

    if (!this.element) {
        throw 'Element is required.';
    }

    if (this.scrollableElement) {
        var _this = this;
        jQuery(this.scrollableElement).scroll(function(e) {
            _this.onContentScrolled(e);
        });
    }

    this.container = args.container;
};

ToolTipErrorReporter.prototype.report = function(value, result) {
    this.remove();

    this.value = value;
    this.result = result;
    this.show();
};

ToolTipErrorReporter.prototype.remove = function() {
    this.value = null;
    this.result = null;
    this.hide();
};

ToolTipErrorReporter.prototype.hide = function() {
    if (this.errorToolTipView) {
        this.errorToolTipView.hide();
        this.errorToolTipView = null;
    }
};

ToolTipErrorReporter.prototype.show = function() {
    if (this.value || this.result) {
        var message = this['message'];
        message = _.isFunction(message) ? message.call(this, this.value, this.result) : message;

        this.errorToolTipView = new ErrorToolTipView({
            el: jQuery(this.element),
            content: message,
            placement: this.position,
            container: this.container
        });

        this.errorToolTipView.show();
    }
};

ToolTipErrorReporter.prototype.onContentScrolled = function(e) {
    this.hide();

    var _this = this;
    if (!this.pendingShow) {
        this.pendingShow = true;
        setTimeout(function() {
            _this.show();
            _this.pendingShow = false;
        }, 200);
    }
};

export default ToolTipErrorReporter;
